var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFrame(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 51,
    viewBox: "0 0 118 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_979_113)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.7597 25.4944L53.6622 42.1597H61.7236C62.3271 42.1589 62.9218 42.0145 63.4596 41.7384C63.9975 41.4623 64.4632 41.0621 64.8191 40.5704L75.7571 25.4944L64.7425 10.3081C64.411 9.84916 63.9766 9.47589 63.4747 9.21885C62.9728 8.96181 62.4177 8.82829 61.8549 8.82923H53.6622L65.7597 25.4944Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4516 27.8894C30.5398 29.9681 31.4392 31.9272 32.9535 33.3394C34.4678 34.7516 36.4742 35.5022 38.5349 35.4274C39.9325 35.5056 41.3204 35.1512 42.5129 34.4116C43.7053 33.6719 44.6453 32.5823 45.2071 31.2887H54.3076C53.6958 33.5455 52.6019 35.64 51.1027 37.425C49.6416 39.159 47.8189 40.5458 45.7649 41.4865C43.5195 42.4994 41.0817 43.0041 38.6224 42.9654C35.5369 43.0118 32.4922 42.2513 29.7844 40.7581C27.2386 39.3554 25.1379 37.2549 23.7247 34.699C22.2853 31.8955 21.5341 28.7843 21.5341 25.6269C21.5341 22.4696 22.2853 19.3584 23.7247 16.5549C25.0994 13.935 27.1815 11.7615 29.7297 10.2861C32.4261 8.81495 35.4396 8.03542 38.5048 8.01617C41.5701 7.99693 44.5929 8.73856 47.3072 10.1757C54.067 14.0827 55.6311 20.4287 55.0733 27.8342H30.4516V27.8894ZM30.6157 21.9959H46.0384C45.9338 20.2321 45.1485 18.58 43.8508 17.3936C42.3806 16.2121 40.5626 15.5577 38.6831 15.5337C36.8037 15.5098 34.9699 16.1175 33.4705 17.2612C31.9682 18.4207 30.9593 20.1134 30.6485 21.9959",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.76143 14.4579C11.5616 10.0433 15.7509 8.15604 20.7933 8.15604V17.6916H18.1244C14.9743 17.6916 11.8022 18.42 10.1177 21.3447C9.26619 23.1238 8.86412 25.0878 8.94737 27.0617V42.2701H-0.0218506V8.93963H8.01764L8.76143 14.4579Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.9076 25.4945L104.502 7.15909e-06H95.5222C95.1984 -0.00198814 94.879 0.075295 94.5913 0.225232C94.3037 0.375168 94.0563 0.593282 93.8706 0.860859L75.8993 25.4945L93.7831 50.1281C93.972 50.3924 94.22 50.6081 94.507 50.7576C94.7939 50.9072 95.1117 50.9864 95.4347 50.989H104.404L85.9076 25.4945Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.924 25.4944L118.011 42.1376H109.95C109.346 42.1368 108.751 41.9925 108.214 41.7163C107.676 41.4402 107.21 41.0401 106.854 40.5483L95.916 25.4944L106.931 10.3081C107.262 9.84916 107.697 9.47589 108.199 9.21885C108.7 8.96181 109.255 8.82829 109.818 8.82923H118.011L105.924 25.4944Z",
    fill: "#7399EF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_979_113"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 118,
    height: 51,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame);
export default __webpack_public_path__ + "static/media/Frame.7e35ec8af882ef3d77020bce8bbd49da.svg";
export { ForwardRef as ReactComponent };